import { render, staticRenderFns } from "./switch-pet.vue?vue&type=template&id=72247724&scoped=true&lang=pug"
import script from "./switch-pet.js?vue&type=script&lang=js&external"
export * from "./switch-pet.js?vue&type=script&lang=js&external"
import style0 from "./switch-pet.vue?vue&type=style&index=0&id=72247724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72247724",
  null
  
)

export default component.exports